import React from 'react'
import notifyHelper from 'sb-notify-me/helper'


const show = (tplName, props) => notifyHelper.addNotification(tplName, props)


export default {
  show,
}
